import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';

const ViewInactivePluginsToggle = ({ styles = {} }) => {
    const includeInactivePlugins = useSelector(state => state.missionControl.includeInactivePlugins);
    
    const dispatch = useDispatch();

    const onChange = useCallback(() => {
        dispatch(
            actions.missionControl.setIncludeInactivePlugins(
                !includeInactivePlugins
            )
        )
    }, [includeInactivePlugins, dispatch]);

    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={includeInactivePlugins}
            label=''
        />
    );
};

export default ViewInactivePluginsToggle;